export default {
  mounted() {
    document.addEventListener('focusin', this.focusIn);
  },
  methods: {
    focusIn(event) {
      if (!this.isActive) return;

      if (event.target === this.$el || this.$el.contains(event.target)) return;
      /*eslint-disable */
      const parent = this.container ? this.container : (this.isFullPage ? null : this.$el.parentElement);
      /*eslint-enable */
      if (this.isFullPage || (parent && parent.contains(event.target))) {
        event.preventDefault();
        this.$el.focus();
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener('focusin', this.focusIn);
  },
};
